<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-29 18:51:33
-->
<template>
  <div class="app-container">
    <!-- <div id="mapContain" class="mapContain"></div> -->
    <div class="title">{{ name }}活动</div>
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="标题" prop="activityName">
          <el-input
            v-model="ruleForm.activityName"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select
            v-model="ruleForm.activityKind"
            placeholder="请选择活动类型"
            clearable
          >
            <el-option
              v-for="item in activityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域：" prop="areaCode">
          <el-radio-group
            v-model="ruleForm.areaCode"
            size="small"
            :disabled="ruleForm.status && ruleForm.status !== 1"
          >
            <el-radio-button
              :label="item.code"
              v-for="item in areaList"
              :key="item.code"
              style="margin: 0 0 10px 0"
              >{{ item.county }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="ruleForm.address" readonly>
            <template slot="append">
              <div @click="getMap">
                <i class="el-icon-location-information"></i>
                获取定位
              </div>
            </template></el-input
          >
        </el-form-item>
        <el-form-item label="活动时间：" prop="videoTime">
          <el-date-picker
            :disabled="ruleForm.status && ruleForm.status !== 1"
            v-model="ruleForm.videoTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="指导单位：" prop="">
          <el-input v-model="ruleForm.guideUnit"></el-input>
        </el-form-item>
        <el-form-item label="主办单位：" prop="hostUnit">
          <el-input v-model="ruleForm.hostUnit"></el-input>
        </el-form-item>
        <el-form-item label="承办单位：" prop="">
          <el-input v-model="ruleForm.underUnit"></el-input>
        </el-form-item>
        <el-form-item label="协办单位：" prop="">
          <el-input v-model="ruleForm.assistingUnit"></el-input>
        </el-form-item>
        <el-form-item label="支持单位：" prop="">
          <el-input v-model="ruleForm.supportUnit"></el-input>
        </el-form-item>
        <el-form-item label="报名人数设置：" prop="numSet">
          <el-input-number
            v-model="ruleForm.numSet"
            controls-position="right"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="内容简介：">
          <div id="editor"></div>
        </el-form-item>

        <el-form-item label="活动封面：" prop="coverUrl" ref="imageId">
          <el-upload
            :class="{ hide: hideUpload }"
            :headers="uploadHeader"
            :action="uploadFileByContentType"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
            :on-change="handleChange"
            :limit="1"
            :file-list="fileList"
            accept=".jpg, .png, .jpeg"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="docSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="ruleForm.coverUrl" alt="" />
          </el-dialog>
          <div class="el-upload__tip">
            建议尺寸690*240或比例25:8，小于5M的JPG、PNG格式图片
          </div>
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            ref="uploader"
            :action="uploadFileByContentType"
            :before-upload="beforeAvatarUpload1"
            :on-remove="handleRemove1"
            multiple
            accept=".ppt, .pptx, .doc, .docx, .pdf, .xls"
            :headers="uploadHeader"
            :limit="1"
            :file-list="fileList1"
            :on-success="docSuccess1"
            :on-exceed="handleExceed"
          >
            <el-button icon="el-icon-upload2">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              支持扩展名：.ppt .pptx .doc .docx .pdf .xls
              .xlsx,文件大小不超过100M，只能上传1个
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="是否同步开启线上直播"
          prop="desc"
          label-width="160px"
        >
          <el-switch v-model="ruleForm.isLive" @change="changeIsLive">
          </el-switch>
        </el-form-item>
        <el-form-item label="类型：" prop="liveType" v-if="ruleForm.isLive">
          <el-select
            v-model="ruleForm.liveType"
            placeholder="请选择直播类型"
            clearable
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="直播封面："
          prop="imgUrl3"
          ref="imageId3"
          v-if="ruleForm.isLive"
        >
          <el-upload
            :class="{ hide: hideUpload3 }"
            :headers="uploadHeader"
            :action="uploadFileByContentType"
            list-type="picture-card"
            :on-change="handleChange3"
            :limit="1"
            :before-upload="beforeAvatarUpload3"
            :file-list="fileList3"
            accept=".jpg, .png, .jpeg"
            :on-preview="handlePictureCardPreview3"
            :on-remove="handleRemove3"
            :on-success="docSuccess3"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible3" width="40%">
            <img width="100%" :src="ruleForm.imgUrl3" alt="" />
          </el-dialog>
          <div class="el-upload__tip">
            支持图片类型：png,
            jpg，最大不超过5M；建议上传大小为690*240像素的图片
          </div>
        </el-form-item>
        <el-form-item
          label="直播回看封面："
          prop="imgUrl2"
          ref="imageId2"
          v-if="ruleForm.isLive"
        >
          <el-upload
            :class="{ hide: hideUpload2, column: true }"
            :headers="uploadHeader"
            :action="uploadFileByContentType"
            list-type="picture-card"
            :on-change="handleChange2"
            :limit="1"
            :before-upload="beforeAvatarUpload2"
            :file-list="fileList2"
            accept=".jpg, .png, .jpeg"
            :on-preview="handlePictureCardPreview2"
            :on-remove="handleRemove2"
            :on-success="docSuccess2"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible2" width="40%">
            <img width="100%" :src="ruleForm.imgUrl2" alt="" />
          </el-dialog>
          <div class="el-upload__tip">
            支持图片类型：png,
            jpg，最大不超过5M；建议上传大小为210*297像素的图片
          </div>
        </el-form-item>
        <el-form-item label="直播地址:" prop="liveUrl" v-if="ruleForm.isLive">
          <el-input v-model="ruleForm.liveUrl"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            :disabled="disabled"
            >提交</el-button
          >
          <el-button @click="resetForm()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="" :visible.sync="mapShow" width="70%">
      <div slot="footer">
        <div class="search">
          <el-select
            v-model="tipInput"
            class="tipInput"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="搜地点"
            :remote-method="remoteMethod"
            :loading="loading"
            @change="tipChange"
          >
            <el-option
              v-for="item in tips"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.district
              }}</span>
            </el-option>
          </el-select>

          <el-button type="primary" @click="mapShow = false">确 定</el-button>
        </div>
        <div id="mapContain" class="mapContain"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getArea } from '@api/video/video'
import { wEditorDefaultConfig } from '@constant'
import { initYxjcAmap } from '@/common/map/map.js'
import {
  addActivityData,
  getActivityData,
  updateActivityData,
  uploadFileByContentType,
  getLiveTypeList
} from '@api/activityCenter/activityCenter'
import { isHttp, getToken } from '@utils'
export default {
  name: 'Live',
  data() {
    return {
      tipInput: '',
      loading: false,
      tips: [],
      mapShow: false,
      uploadFileByContentType,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      name: '新增',
      dialogVisible: false,
      dialogVisible3: false,
      dialogVisible2: false,
      hideUpload: false,
      hideUpload2: false,
      hideUpload3: false,
      ruleForm: {
        id: '', // 直播id
        activityName: '', // 直播名称
        activityKind: '', // 活动类型
        areaCode: '', // 区域code
        address: '', // 详细地址
        lng: '', // 经度
        lat: '', // 维度
        county: '', // 区域
        isLive: false, // 是否同步开启线上直播
        videoTime: '', // 直播时间
        startTime: '', // 直播开始时间
        endTime: '', // 直播结束时间
        numSet: 30, // 报名人数
        hostUnit: '', // 主办单位
        guideUnit: '', // 指导单位
        underUnit: '', // 承办单位
        assistingUnit: '', // 协办单位
        supportUnit: '', // 支持单位
        content: '', // 内容简介
        coverUrl: '', // 活动封面地址
        liveUrl: '', // 直播地址
        liveType: '', // 直播类型
        ossUrl: '', // 附件ulr
        fileName: '', // 附件名称
        isDeploy: '', // 是否上架（0.下架，1.上架）
        imgUrl: null, // 直播同步封面
        imgUrl3: null,
        imgUrl2: null
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        hostUnit: [
          { required: true, message: '请输入主办单位', trigger: 'blur' }
        ],
        numSet: [
          { required: true, message: '请输入报名人数', trigger: 'blur' }
        ],
        liveType: [
          { required: true, message: '请选择直播类型', trigger: 'change' }
        ],
        videoTime: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        imgUrl3: [{ required: true, message: '请上传文件', trigger: 'change' }],
        imgUrl2: [{ required: true, message: '请上传文件', trigger: 'change' }],
        coverUrl: [
          { required: true, message: '请上传文件', trigger: 'change' }
        ],
        liveUrl: isHttp()
      },
      typeList: [], // 所有类别数据
      areaList: [],
      disabled: true,
      map: null,
      markers: [],
      markersPosition: [],
      geoCoder: null,
      activityList: [
        { value: '1', label: '信息服务' },
        { value: '2', label: '投融资服务' },
        { value: '3', label: '创业服务' },
        { value: '4', label: '人才培训' },
        { value: '5', label: '培训服务' },
        { value: '6', label: '技术创新和质量服务' },
        { value: '7', label: '数字化赋能服务' },
        { value: '8', label: '管理咨询' },
        { value: '9', label: '市场开拓' },
        { value: '10', label: '法律服务' }
      ]
    }
  },
  watch: {
    condition(val) {
      if (this.aRoute(val)) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  computed: {
    condition({ ruleForm }) {
      return {
        activityName: ruleForm.activityName,
        areaCode: ruleForm.areaCode,
        address: ruleForm.address,
        hostUnit: ruleForm.hostUnit,
        videoTime: ruleForm.videoTime,
        numSet: ruleForm.numSet,
        coverUrl: ruleForm.coverUrl,
        isLive: ruleForm.isLive
      }
    }
  },
  created() {
    this.getArea()
    this.getLiveTypeList()
  },
  mounted() {
    if (this.$route.query.id) {
      this.getActivityData()
      this.name = '编辑'
    }
    this.wangEditor()
    this.initMap()
  },
  methods: {
    tipChange(value) {
      for (const tip of this.tips) {
        if (value === tip.id) {
          this.map.setZoom(14)
          this.map.setCenter(tip.location)
          this.ruleForm.lng = tip.location.lng
          this.ruleForm.lat = tip.location.lat
          this.ruleForm.address = tip.name
          this.markersPosition = [tip.location.lng, tip.location.lat]
          this.setMapMarker()
          break
        }
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        const that = this
        AMap.plugin('AMap.Autocomplete', function () {
          // 实例化Autocomplete
          const autoOptions = {
            city: '丽水'
          }
          const autoComplete = new AMap.Autocomplete(autoOptions)
          autoComplete.search(query, function (status, result) {
            // 搜索成功时，result即是对应的匹配数据
            that.tips = result.tips || []
            that.loading = false
          })
        })
      } else {
        this.tips = []
      }
    },
    getMap() {
      this.mapShow = true
      if (this.ruleForm.lng && this.ruleForm.lat) {
        this.markersPosition = [this.ruleForm.lng, this.ruleForm.lat]
        this.map.setCenter(this.markersPosition)
        this.setMapMarker()
      }
    },
    /**
     * @description 初始化地图
     */
    initMap() {
      // 渲染地图
      this.map = new AMap.Map('mapContain', {
        resizeEnable: true,
        center: [119.921786, 28.451993], // 中心点坐标
        showLabel: true, // 不显示地图文字标记
        viewMode: '2D',
        zoomEnable: true,
        dragEnable: true,
        zoom: 15,
        pitch: 10
      })
      this.handlerMapClick()
    },
    handlerMapClick() {
      this.map.on('click', e => {
        // 点击坐标
        this.ruleForm.lng = e.lnglat.lng
        this.ruleForm.lat = e.lnglat.lat
        this.markersPosition = [e.lnglat.lng, e.lnglat.lat]
        this.removeMarker()
        // 设置新的标记
        this.setMapMarker()
        // eslint-disable-next-line no-undef
        // 根据坐标获取位置信息
        // AMap.plugin('AMap.Geocoder', function() {
        let geoCoder
        AMap.plugin('AMap.Geocoder', function () {
          geoCoder = new AMap.Geocoder()
        })
        // console.log(this.markersPosition)
        geoCoder.getAddress(this.markersPosition, (status, result) => {
          if (status === 'complete' && result.regeocode) {
            this.ruleForm.address = result.regeocode.formattedAddress
            // console.log('点击位置信息：', result.regeocode.formattedAddress)
            // id
            this.tipInput = this.ruleForm.address
            let adcode = result.regeocode.addressComponent.adcode
            //   let reg = /.+?(省|市|自治区|自治州|县|区)/g
            let provinceId = parseInt(adcode.substr(0, 2) + '0000')
            let cityId = parseInt(adcode.substr(0, 4) + '00')
            let areaId = adcode
            // console.log('点击位置的省市区id：', provinceId, cityId, areaId)
          }
        })
        // })
      })
    },
    // 设置点击位置的标记
    setMapMarker() {
      let marker = new AMap.Marker({
        map: this.map,
        position: this.markersPosition
      })
      // 将 markers 添加到地图
      this.markers.push(marker)
    },
    // 删除之前后的标记点
    removeMarker() {
      if (this.markers) {
        this.map.remove(this.markers)
      }
    },
    /** 创建富文本编辑器 */
    wangEditor() {
      let E = window.wangEditor
      this.editor = new E('#editor')
      this.editor.customConfig = {
        ...this.editor.customConfig,
        ...wEditorDefaultConfig
      }
      // console.log(this.editor.customConfig)
      // 配置菜单栏，设置不需要的菜单
      // this.editor.config.excludeMenus = [
      //   'video'
      // ]
      // 富文本编辑器内容校验
      let that = this
      this.editor.customConfig.onblur = function (html) {
        // 失去焦点时触发校验
        if (that.editor.txt.html() == '<p><br></p>') {
          that.$refs.ruleForm.validateField('content')
        } else {
          that.$refs.ruleForm.clearValidate('content')
        }
      }
      this.editor.create()
    },
    getTime() {
      console.log(this.ruleForm.videoTime)
    },
    changeIsLive(val) {
      if (!val) {
        if (!this.$route.query.id) {
          this.ruleForm.liveUrl = ''
          this.ruleForm.liveType = ''
          this.ruleForm.imgUrl2 = ''
          this.ruleForm.imgUrl3 = ''
          this.hideUpload2 = false
          this.hideUpload3 = false
        }
      }
    },
    aRoute(object) {
      // 判断对象内容是否为空
      let isEmpty = Object.keys(object).every(x => {
        // console.log(object[x])
        return object[x] !== ''
      })
      return isEmpty
    },
    /** 获取企业详情 */
    getActivityData() {
      getActivityData({ id: this.$route.query.id }).then(res => {
        if (res.data.code == '0000') {
          this.ruleForm = { ...res.data.data }
          if (this.ruleForm.numSet) {
            this.ruleForm.numSet =
              this.ruleForm.numSet > 0 ? this.ruleForm.numSet : 1
          } else {
            this.$set(this.ruleForm, 'numSet', 30)
          }
          this.$set(this.ruleForm, 'videoTime', [
            this.ruleForm.startTime,
            this.ruleForm.endTime
          ])
          this.ruleForm.isLive = this.ruleForm.isLive == 1
          this.editor.txt.html(this.ruleForm.content)
          this.fileList = [{ name: '', url: this.ruleForm.coverUrl }]
          this.fileList3 = this.ruleForm.imgUrl
            ? [{ name: '', url: this.ruleForm.imgUrl.split(',')[0] }]
            : []
          this.fileList2 = this.ruleForm.imgUrl
            ? [{ name: '', url: this.ruleForm.imgUrl.split(',')[1] }]
            : []
          this.$set(
            this.ruleForm,
            'imgUrl3',
            this.ruleForm.imgUrl ? this.ruleForm.imgUrl.split(',')[0] : null
          )
          this.$set(
            this.ruleForm,
            'imgUrl2',
            this.ruleForm.imgUrl ? this.ruleForm.imgUrl.split(',')[1] : null
          )
          if (this.ruleForm.ossUrl) {
            this.fileList1 = [
              { name: this.ruleForm.fileName, url: this.ruleForm.ossUrl }
            ]
          }
          this.hideUpload = this.fileList.length >= 1
          this.hideUpload2 = this.fileList2.length >= 1
          this.hideUpload3 = this.fileList3.length >= 1
        }
      })
    },
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
        }
      })
    },
    /** 获取直播类型 */
    getLiveTypeList() {
      getLiveTypeList({}).then(res => {
        if (res.data.code == '0000') {
          this.typeList = res.data.data || []
        }
      })
    },
    /**
     * @name:视频新增或者编辑
     * @test: test font
     * @msg:
     * @param {*} formName
     * @return {*}
     */
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = { ...this.ruleForm }
          data.content = this.editor.txt.html()
          data.imgUrl = data.imgUrl3 + ',' + data.imgUrl2
          data.startTime = data.videoTime[0]
          data.endTime = data.videoTime[1]
          data.isLive = data.isLive ? 1 : 0
          this.areaList.forEach(item => {
            if (item.code == data.areaCode) {
              data.county = item.county
            }
          })
          if (this.$route.query.id) {
            updateActivityData(data).then(res => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.$router.push({ name: 'activityList' })
              } else {
                this.$message.error(res.data.msg)
              }
            })
          } else {
            addActivityData(data).then(res => {
              if (res.data.code == '0000') {
                this.$message.success(res.data.msg)
                this.$router.push({ name: 'activityList' })
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$router.push({ name: 'activityList' })
    },
    handleChange(file, fileList) {
      this.hideUpload = fileList.length >= 1
    },
    handleChange2(file, fileList) {
      this.hideUpload2 = fileList.length >= 1
    },
    handleChange3(file, fileList) {
      this.hideUpload3 = fileList.length >= 1
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
      this.hideUpload = fileList.length >= 1
      this.ruleForm.coverUrl = ''
    },
    handleRemove2(file, fileList) {
      // console.log(file, fileList)
      this.hideUpload2 = fileList.length >= 1
      this.ruleForm.imgUrl2 = ''
    },
    handleRemove3(file, fileList) {
      // console.log(file, fileList)
      this.hideUpload3 = fileList.length >= 1
      this.ruleForm.imgUrl3 = ''
    },
    handleRemove1(file, fileList) {
      this.ruleForm.ossUrl = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handlePictureCardPreview2(file) {
      this.dialogVisible2 = true
    },
    handlePictureCardPreview3(file) {
      this.dialogVisible3 = true
    },
    docSuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.coverUrl = response.data.ossUrl
        this.$refs.imageId.clearValidate()
      }
      // this.$refs.form.clearValidate('imageId')
    },
    docSuccess2(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.imgUrl2 = response.data.ossUrl
        this.$refs.imageId2.clearValidate()
      }
      // this.$refs.form.clearValidate('imageId')
    },
    docSuccess3(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.imgUrl3 = response.data.ossUrl
        console.log(this.ruleForm.imgUrl3)
        this.$refs.imageId3.clearValidate()
      }
      // this.$refs.form.clearValidate('imageId')
    },
    docSuccess1(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.ossUrl = response.data.ossUrl
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    beforeAvatarUpload2(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    beforeAvatarUpload3(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    beforeAvatarUpload1(file) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
      }
      return isLt2M
    },
    handleExceed() {
      this.$message.warning('当前限制选择 1 个文件，已上传了1个文件')
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.column {
  /deep/ .el-upload--picture-card {
    width: 105px;
    height: 148.5px;
    line-height: 148.5px;
  }
  /deep/ .el-upload-list__item {
    width: 105px;
    height: 148.5px;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog {
    background: #f7f7f7;
  }
  .el-dialog__body {
    // height: 600px;
    overflow: auto;
    padding: 0 0 20px !important;
    font-size: 16px;
  }
}
/deep/ .el-upload--picture-card {
  width: 276px;
  height: 96px;
  line-height: 96px;
}
/deep/ .el-upload-list__item {
  width: 276px;
  height: 96px;
}
.app-container {
  overflow-y: auto;
  & > .content {
    margin-top: 30px;
    width: 65%;
  }
}
.search {
  position: absolute;
  top: 70px;
  left: 70px;
  z-index: 1000;
  /deep/ .el-input__inner {
    width: 420px;
  }
  /deep/ .el-button {
    margin-left: 20px;
  }
}
.mapContain {
  width: 100%;
  height: 600px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
/deep/ .amap-copyright {
  opacity: 0 !important;
}
/deep/ .amap-logo {
  display: none !important; //去掉高德地图logo
}
</style>
